// extracted by mini-css-extract-plugin
export default {"switch":"Switch_switch__ZGaqU","label":"Switch_label__fkd5u","displayLarge":"Switch_displayLarge__RDiz-","displaySmall":"Switch_displaySmall__oOAAD"};